(function () {
  "use strict";

  var reduced = window.matchMedia("(prefers-reduced-motion: reduce)").matches;

  /* Every asset URL comes from here. This file is a static asset and cannot
     call Liquid's asset_url itself, so layout/theme.liquid hands the resolved
     CDN paths over on window.VEYIA_ASSETS.
     This declaration MUST stay above the IMAGERY block. It used to sit further
     down, next to products[], which meant the hero constants below could not
     read it and silently got undefined. */
  var A = window.VEYIA_ASSETS || {};

  /* ============================================================
     IMAGERY — fill these and the slots render photographs
     ============================================================ */
  // The hero takes a film. HERO_IMAGE doubles as its poster frame —
  // shown while the video loads, and shown instead of it when the
  // viewer has asked for reduced motion.
  /* Phones get the 720p cut, everything else the 4K master. Decided once at
     load from the viewport, not from a media query on <source> (whose support
     across mobile browsers is inconsistent enough not to trust with the hero).
     A missing mobile file falls back to the master rather than to nothing. */
  var HERO_SMALL    = window.matchMedia && window.matchMedia("(max-width: 767px)").matches;
  var HERO_VIDEO    = (HERO_SMALL && A["hero-film-mobile"]) || A["hero-film"] || "";
  var HERO_IMAGE    = A["hero-poster"] || "";
  var CLOSEUP_VIDEO = "";
  // The fit slot takes a film too. A ratchet closing is a movement, and a
  // still frame cannot show it. ADJUST_IMAGE is the poster and the fallback.
  var ADJUST_VIDEO  = "";
  var ADJUST_IMAGE  = "";
  var CLOSEUP_IMAGE = "";

  /* The category tier is GONE, not reduced. It went 8 tiles (gendered
     Bracelets / Rings / Necklaces / Sets) to 2, then to none, on 2026-08-11.
     With a four-piece range the product grid IS the catalogue and a category
     click can only ever land on three items or one. Order in `products[]` is
     the merchandising: necklaces first. */

  /* The four pieces that physically exist, photographed 2026-08-11.
     Replaces the prototype's invented 8-SKU range (2 bracelets, 2 rings,
     2 necklaces, 2 sets) which matched none of the real samples.

     THREE THINGS HERE ARE STILL UNVERIFIED. Do not let them ship as fact:
       price   - inherited placeholders from the prototype ladder. No piece has
                 been weighed and no unit cost is known, so every number is a
                 draft. See CONTINUE-HERE.md open question #1.
       length  - not one chain has been measured. Omitted rather than invented.
       material- only the gold disc is confirmed, from an S925 stamp on its end
                 tag. The three silver pieces are unconfirmed.
     Notes below describe only hardware that is visible in the reference photos.
     `A` is declared at the top of this file, above the IMAGERY block. */

  var products = [
    { id: "p1", cat: "necklaces", name: "Rope Chain Necklace", ref: "VY-101", price: 89,
      image: A["rope-chain-necklace"] || "", film: A["rope-chain-necklace-film"] || "", tag: "", material: "Sterling silver",
      finishes: ["Silver"], sizes: ["One size"],
      note: "A 2 mm twisted rope, polished to a high shine so it catches light along its whole length. Closes on a lobster clasp." },

    { id: "p2", cat: "necklaces", name: "Bar Pendant", ref: "VY-102", price: 85,
      image: A["bar-pendant"] || "", film: A["bar-pendant-film"] || "", tag: "", material: "Sterling silver",
      finishes: ["Silver"], sizes: ["One size"],
      note: "A slim mirror-polished bar that hangs vertically on a fine cable chain. One clean line, nothing else." },

    { id: "p3", cat: "necklaces", name: "Gold Disc Pendant", ref: "VY-103", price: 85,
      image: A["gold-disc-pendant"] || "", film: A["gold-disc-pendant-film"] || "", tag: "Adjustable", material: "Gold-plated sterling silver",
      finishes: ["Gold"], sizes: ["One size"],
      note: "A plain polished disc on a fine cable chain. A slider bead runs on the chain, so you set the length by hand and it holds there." },

    { id: "p4", cat: "bracelets", name: "Snake Chain Bracelet", ref: "VY-201", price: 75,
      image: A["snake-chain-bracelet"] || "", film: A["snake-chain-bracelet-film"] || "", tag: "Bestseller", material: "Sterling silver",
      finishes: ["Silver"], sizes: ["One size"],
      note: "A flat snake chain that wraps the wrist twice and sits flush against it. Lobster clasp with an extender chain." }
  ];

  var FREE_SHIP = 75;
  var usd = new Intl.NumberFormat("en-US", { style: "currency", currency: "USD", maximumFractionDigits: 0 });

  /* Product tile media: still underneath, optional film on top.
     The film is the hover state. It stays paused and invisible until the
     tile is hovered or keyboard-focused, so nothing downloads or decodes
     for a visitor who never reaches for it.

     preload="none" is deliberate. Four autoloading 5s films above the fold
     would cost more than every other asset on the page combined, and the
     whole point of the still is that it carries the tile on its own.

     Reduced motion gets the still and nothing else. */
  /* `focal` tunes the crop. The films are 16:9 and the tile is 4:5, so cover
     scales to fill the height and throws away the sides. Full height survives;
     horizontal framing is the only thing worth steering. Give a product
     `focal: "30% center"` to pull the visible window left, "70% center" right.
     Omit it and the crop is centred, which is right for a centred subject. */
  function hoverFill(src, video, alt, ratio, focal) {
    var still = slotFill(src, alt, ratio);
    if (!video || reduced) return still;
    return still +
      '<video class="prod-film" muted loop playsinline preload="none" tabindex="-1" ' +
        'aria-hidden="true"' + (focal ? ' style="object-position: ' + focal + '"' : '') +
        '><source src="' + video + '" type="video/mp4"></video>';
  }

  function slotFill(src, alt, ratio, parallax) {
    if (src) {
      return '<div class="slot-inner"' + (parallax ? ' data-parallax="' + parallax + '"' : '') + '>' +
               '<img src="' + src + '" alt="' + alt + '" loading="lazy"></div>';
    }
    return '<div class="slot-empty" role="img" aria-label="' + alt + ' — photography pending">' +
             '<i></i><i></i><i></i><i></i>' +
             '<span>' + alt + '</span><span>' + ratio + '</span></div>';
  }

  /* Film first, poster second, crop marks last.
     autoplay needs muted + playsinline or mobile refuses to start it. */
  function mediaFill(video, poster, alt, ratio, parallax) {
    if (video && !reduced) {
      return '<div class="slot-inner"' + (parallax ? ' data-parallax="' + parallax + '"' : '') + '>' +
               '<video autoplay muted loop playsinline preload="auto" aria-label="' + alt + '"' +
               (poster ? ' poster="' + poster + '"' : '') +
               '><source src="' + video + '"></video></div>';
    }
    if (video && reduced && !poster) {
      // Motion is unwelcome but the frame should not be empty — give
      // them the film on their own terms.
      return '<div class="slot-inner"><video controls muted loop playsinline preload="metadata"' +
             ' aria-label="' + alt + '"><source src="' + video + '"></video></div>';
    }
    return slotFill(poster, alt, ratio, parallax);
  }

  /* ============================================================
     1. SMOKE — REMOVED 2026-08-22
     ============================================================
     The WebGL volumetric plume (five octaves of gradient noise under
     two levels of domain warping) and its 2D sprite fallback lived
     here, about 320 lines. Removed on Jack's instruction when the site
     went light: the plume was pale silver drawn on near-black and has
     no reading on an off-white page.

     Removed WITH its canvas. Earlier notes warned that a missing
     #smoke element throws on getContext and kills this whole script,
     emptying every grid — that was about deleting the ELEMENT while
     leaving the code. Both are gone now, so there is nothing to throw.

     Also gone: the wordmark click handler that re-fired the plume.
     id="wordmark" is kept in the markup as the logo link.

     Recoverable from git: it is intact in commit 7843bc6 and earlier.
     ============================================================ */

  /* ============================================================
     2. RENDER
     ============================================================ */
  /* Every render below is guarded on the element existing. The category grid
     and the fit slot were removed from the markup on 2026-08-11, and an
     unguarded getElementById on a deleted node throws, which would take the
     whole script down and silently empty every remaining grid. That exact
     failure already cost this project a session once. */
  function fill(id, html) {
    var el = document.getElementById(id);
    if (el) el.innerHTML = html;
  }

  fill("heroSlot", mediaFill(HERO_VIDEO, HERO_IMAGE, "Campaign film", "16:9 — Video"));
  // closeupSlot removed with the "On finish" band, 2026-08-11. fill() no-ops
  // on a missing id, so this line is simply gone rather than guarded.

  var grid = document.getElementById("prodGrid");
  grid.innerHTML = products.map(function (p, i) {
    return '<article class="prod rise" data-cat="' + p.cat + '" style="--d: ' + (i * 70) + 'ms">' +
      '<button class="prod-frame" data-p="' + p.id + '" aria-label="View ' + p.name + '">' +
        '<span class="slot prod-slot">' +
          hoverFill(p.image, p.film, p.name, "4:5", p.focal) +
          (p.tag ? '<span class="prod-tag' + (p.was ? '' : ' prod-tag--quiet') + '">' + p.tag + '</span>' : '') +
          '<span class="prod-quick">Quick view</span>' +
        '</span>' +
      '</button>' +
      '<p class="prod-gen">' + (p.cat === "bracelets" ? "Bracelet" : "Necklace") + '</p>' +
      '<h3 class="prod-nm">' + p.name + '</h3>' +
      '<p class="prod-pr">' + usd.format(p.price) + (p.was ? ' <s>' + usd.format(p.was) + '</s>' : '') + '</p>' +
      /* Render from p.finishes. This was hardcoded to silver + gold on every
         tile, which advertised a gold rope chain and a silver disc when each
         real piece comes in one finish only. */
      '<span class="swatches" aria-label="Available in ' + p.finishes.join(" and ").toLowerCase() + '">' +
        p.finishes.map(function (f) {
          return '<i class="sw sw--' + f.toLowerCase() + '"></i>';
        }).join("") +
      '</span>' +
    '</article>';
  }).join("");

  /* ---- Hover film ----
     Delegated on the grid rather than bound per tile, so re-rendering the
     grid never leaves orphaned listeners behind.

     pointerenter/leave, not mouseenter: a touch device fires no hover at all
     and correctly just keeps the still. focusin/focusout gives the same
     preview to keyboard users, who otherwise never see it.

     play() returns a promise that REJECTS if the element is torn out or
     paused mid-start, and an unhandled rejection there is a console error on
     an ordinary mouse-out. Swallow it. */
  (function () {
    var g = document.getElementById("prodGrid");
    if (!g) return;

    /* asset_url returns a URL whether or not the file is actually in assets/,
       so a film that has not been shot yet resolves to a 404 rather than to
       nothing. Left alone that paints an empty black video over the still on
       hover, which is worse than having no hover at all. Drop the element the
       moment the browser reports it cannot load, and the tile silently goes
       back to being a still. */
    g.addEventListener("error", function (e) {
      var t = e.target;
      if (!t) return;
      if (t.tagName === "SOURCE" && t.parentNode && t.parentNode.classList.contains("prod-film")) {
        t.parentNode.remove();
      } else if (t.classList && t.classList.contains("prod-film")) {
        t.remove();
      }
    }, true);

    function film(e) {
      var art = e.target.closest ? e.target.closest(".prod") : null;
      return art ? art.querySelector(".prod-film") : null;
    }
    /* Fade in on `playing`, never on hover. With preload="none" the file is
       not fetched until the first hover, so revealing it optimistically shows
       a black rectangle for as long as the fetch takes, and shows one forever
       if the film does not exist. Waiting for the first decoded frame costs a
       few hundred ms on the very first hover and nothing after that. */
    function start(e) {
      var v = film(e);
      if (!v) return;
      // Already buffered from an earlier hover: reveal now, no wait.
      // HAVE_CURRENT_DATA (2) means there is a frame to show.
      if (v.readyState >= 2) {
        v.classList.add("is-on");
      } else {
        v.addEventListener("playing", function () {
          v.classList.add("is-on");
        }, { once: true });
      }
      var p = v.play();
      if (p && p.catch) p.catch(function () {});
    }
    function stop(e) {
      var v = film(e);
      if (!v) return;
      v.classList.remove("is-on");
      v.pause();
      // Back to frame one, so the next hover starts the loop rather than
      // resuming it half way through.
      try { v.currentTime = 0; } catch (err) {}
    }

    g.addEventListener("pointerenter", start, true);
    g.addEventListener("pointerleave", stop, true);
    g.addEventListener("focusin", start);
    g.addEventListener("focusout", stop);
  })();

  /* The category filter and the [data-jump] preselect handler were removed on
     2026-08-11 with the filter buttons and the category tier. `p.cat` is still
     carried on each product and still rendered as the tile's caption
     ("Necklace" / "Bracelet"), so the data survives if filtering is ever wanted
     back at a larger range. Nothing hides a product now: all four always show.

     `data-cat` also stays on the article element, for the same reason. */

  /* ============================================================
     3. REVEALS & PARALLAX
     ============================================================ */
  if (reduced) {
    document.querySelectorAll(".rise").forEach(function (n) { n.classList.add("in"); });
  } else {
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add("in"); io.unobserve(e.target); }
      });
    }, { threshold: 0.12, rootMargin: "0px 0px -6% 0px" });
    document.querySelectorAll(".rise").forEach(function (n) { io.observe(n); });

    var ticking = false;
    window.addEventListener("scroll", function () {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function () {
        var vh = window.innerHeight;
        document.querySelectorAll("[data-parallax]").forEach(function (l) {
          var r = l.getBoundingClientRect();
          if (r.bottom < -200 || r.top > vh + 200) return;
          var mid = r.top + r.height / 2 - vh / 2;
          var sh = Math.max(-30, Math.min(30, mid * parseFloat(l.dataset.parallax)));
          l.style.transform = "translate3d(0," + sh.toFixed(2) + "px,0)";
        });
        ticking = false;
      });
    }, { passive: true });
  }

  /* ============================================================
     4. SHOPPING
     ============================================================ */
  var scrim  = document.getElementById("scrim");
  var detail = document.getElementById("detail");
  var bagEl  = document.getElementById("bag");
  var dBody  = document.getElementById("dBody");
  var dRef   = document.getElementById("dRef");
  var bBody  = document.getElementById("bagBody");
  var bCount = document.getElementById("bagCount");
  var bag = [], lastFocus = null, current = null, finish = "Silver";

  function openDrawer(el) {
    lastFocus = document.activeElement;
    [detail, bagEl].forEach(function (d) {
      var on = d === el;
      d.dataset.open = on ? "true" : "false";
      d.setAttribute("aria-hidden", on ? "false" : "true");
    });
    scrim.dataset.open = "true";
    document.body.style.overflow = "hidden";
    var f = el.querySelector("[data-close]");
    if (f) f.focus();
  }

  function closeDrawers() {
    [detail, bagEl].forEach(function (d) {
      d.dataset.open = "false";
      d.setAttribute("aria-hidden", "true");
    });
    scrim.dataset.open = "false";
    document.body.style.overflow = "";
    if (lastFocus) { lastFocus.focus(); lastFocus = null; }
  }

  function showDetail(p) {
    current = p; finish = p.finishes[0];
    dRef.textContent = "Ref. " + p.ref;
    dBody.innerHTML =
      '<div class="slot d-slot">' + slotFill(p.image, p.name, "1:1") + '</div>' +
      '<div style="display:flex;flex-direction:column;gap:6px">' +
        '<p class="prod-gen">' + (p.cat === "bracelets" ? "Bracelet" : "Necklace") + '</p>' +
        '<h2 class="d-nm" id="dName">' + p.name + '</h2>' +
        '<p class="d-pr">' + usd.format(p.price) + (p.was ? ' <s>' + usd.format(p.was) + '</s>' : '') + '</p>' +
      '</div>' +
      '<p class="prose" style="max-width:none">' + p.note + '</p>' +
      '<div class="opt">' +
        '<p class="label">Finish</p>' +
        '<div class="opt-row" id="finRow">' +
          p.finishes.map(function (f, i) {
            return '<button class="chip" data-fin="' + f + '" aria-pressed="' + (i === 0) + '">' +
                     '<i class="sw sw--' + f.toLowerCase() + '"></i>' + f +
                   '</button>';
          }).join("") +
        '</div>' +
      '</div>' +
      '<dl class="d-spec">' +
        '<div><dt>Material</dt><dd>' + p.material + '</dd></div>' +
        '<div><dt>Fit</dt><dd>' + p.length + '</dd></div>' +
        '<div><dt>Warranty</dt><dd>Lifetime</dd></div>' +
        '<div><dt>Delivery</dt><dd>2 to 4 business days</dd></div>' +
      '</dl>' +
      '<a class="add" id="add" href="#contact"><span>Contact us</span></a>';

    dBody.querySelector("#finRow").addEventListener("click", function (e) {
      var b = e.target.closest(".chip");
      if (!b) return;
      finish = b.dataset.fin;
      dBody.querySelectorAll(".chip").forEach(function (c) {
        c.setAttribute("aria-pressed", String(c === b));
      });
    });

    // Cart removed 2026-08-12 on Jack's instruction. There are no Shopify products
    // and no checkout, so add-to-bag now routes to the contact form instead.
    dBody.querySelector("#add").addEventListener("click", function () {
      closeDrawers();
    });

    openDrawer(detail);
  }

  function renderBag() {
    bCount.textContent = String(bag.length);
    if (!bag.length) {
      bBody.innerHTML = '<p class="bag-note">Your bag is empty. Every piece is adjustable, so there is no size to choose.</p>';
      return;
    }
    var total = bag.reduce(function (s, i) { return s + i.price; }, 0);
    var pct = Math.min(100, (total / FREE_SHIP) * 100);
    var left = Math.max(0, FREE_SHIP - total);

    bBody.innerHTML =
      '<div class="ship">' +
        '<p>' + (left > 0
          ? 'Add <b>' + usd.format(left) + '</b> for free shipping'
          : 'Free shipping <b>unlocked</b>') + '</p>' +
        '<div class="ship-track"><div class="ship-fill" style="width:' + pct + '%"></div></div>' +
      '</div>' +
      '<div class="bag-list">' +
        bag.map(function (i, n) {
          return '<div class="bag-item">' +
            '<div class="slot bag-slot">' + slotFill(i.image, i.name, "1:1") + '</div>' +
            '<div><h4>' + i.name + '</h4><p>' + i.finish + '  ·  One size</p></div>' +
            '<button class="bag-rm" data-rm="' + n + '">Remove</button>' +
          '</div>';
        }).join("") +
      '</div>' +
      '<div class="bag-total"><span class="label">Subtotal</span><strong>' + usd.format(total) + '</strong></div>' +
      '<p class="bag-note">Duties included. Lifetime warranty on every piece. 60-day returns.</p>' +
      '<button class="add"><span>Checkout</span></button>';

    bBody.querySelectorAll("[data-rm]").forEach(function (b) {
      b.addEventListener("click", function () {
        bag.splice(parseInt(b.dataset.rm, 10), 1);
        renderBag();
      });
    });
  }

  grid.addEventListener("click", function (e) {
    var b = e.target.closest("[data-p]");
    if (!b) return;
    var p = products.filter(function (x) { return x.id === b.dataset.p; })[0];
    if (p) showDetail(p);
  });

  // Bag button removed from the nav 2026-08-12. Guarded rather than deleted so the
  // whole script does not throw if the element ever comes back or goes missing.
  var bagOpenBtn = document.getElementById("bagOpen");
  if (bagOpenBtn) bagOpenBtn.addEventListener("click", function () { renderBag(); openDrawer(bagEl); });
  scrim.addEventListener("click", closeDrawers);
  document.querySelectorAll("[data-close]").forEach(function (b) { b.addEventListener("click", closeDrawers); });
  document.addEventListener("keydown", function (e) { if (e.key === "Escape") closeDrawers(); });

  document.getElementById("newsForm").addEventListener("submit", function (e) {
    e.preventDefault();
    document.getElementById("newsMsg").textContent = "Thanks, your code is on its way.";
    e.target.reset();
  });

  renderBag();
})();
